import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { DefaultForm } from "../../components";
import { GlanceAdjustmentTypeEnum } from "../../entities/enums";
import { GlanceAdjustmentCollectModel } from "../../entities/glance";
import { useGetCompaniesSelectFilterQuery } from "../../features/api/apiSlice";

interface GlanceAdjustmentCollectorProps {
  collectCallback: (data: GlanceAdjustmentCollectModel) => Promise<boolean>;
}

export const GlanceAdjustmentCollector = ({ collectCallback }: GlanceAdjustmentCollectorProps) => {
  const [isCollecting, setIsCollecting] = useState(false);

  let model: GlanceAdjustmentCollectModel = {
      symbols: [],
      adjustmentType: GlanceAdjustmentTypeEnum.Unadjusted,
      authorization: ""
  };

  const onFinish = async (values: any) => {
    let collectModel: GlanceAdjustmentCollectModel = {
      ...values
    };

    setIsCollecting(true);

    await collectCallback(collectModel);

    setIsCollecting(false);
  };

  return (
    <DefaultForm onFinish={onFinish} layout="vertical" initialValues={model}>
      <DefaultForm.DataSelect name="symbols" label="none" placeholder="انتخاب شرکت ها" multiple={true} recordId={x=>x.symbol} wrapperCol={{xs: 24, lg: 12}}
        query={useGetCompaniesSelectFilterQuery}
        displayText={(x) => `${x.symbol} (${x.name})`}
        isPersian={true}
      />

      <DefaultForm.EnumSelect name="adjustmentType" type={GlanceAdjustmentTypeEnum} wrapperCol={{xs: 24, md: 12, lg:6}} />

      <DefaultForm.TextInput name="authorization" wrapperCol={{xs: 24, md: 12, lg:6}} />

      <DefaultForm.SubmitButton loading={isCollecting} icon={<FontAwesomeIcon className="anticon" icon={faPlusCircle} />}>
          کالکت
      </DefaultForm.SubmitButton>
    </DefaultForm>
  );
};
